import qs from 'qs';
import { network } from 'services/network';

export const getKeyActivitiesTags = (params) => {
    const querystring = qs.stringify({ contractId: params.contractId }, { addQueryPrefix: true, skipNulls: true });
    return network.get(`api/bo/getKeyActivitiesTags${querystring}`).then((response) => {
        return response.data;
    });
};
